export function getNavigation(i18n) {
  return [
    {
      text: i18n.t('navigation.home'),
      path: "/home",
      icon: "home"
    },
    {
      text: i18n.t('navigation.productionLines'),
      icon: "aligncenter",
      items: [
        {
          text: i18n.t('navigation.productionLinesList'),
          path: "/production-lines-list"
        }
      ]
    },
    {
      text: i18n.t('navigation.orders'),
      icon: "cart",
      items: [
        {
          text: i18n.t('navigation.manageOrders'),
          path: "/orders",
        },
        {
          text: i18n.t('navigation.newOrder'),
          path: "/new-order",
        }
      ]
    },
    {
      text: i18n.t('navigation.forecasts'),
      icon: "tableproperties",
      items: [
        {
          text: i18n.t('navigation.manageForecasts'),
          path: "/forecasts"
        },
        {
          text: i18n.t('navigation.newForecasts'),
          path: "/new-forecasts",
        }
      ]
    },
    {
      text: i18n.t('navigation.manageAccount'),
      icon: "preferences",
      items: [
        {
          text: i18n.t('navigation.manageUsers'),
          path: "/manage-account"
        }
      ]
    },
    {
      text: i18n.t('navigation.account'),
      icon: "user",
      items: [
        {
          text: i18n.t('navigation.editRegistration'),
          path: "/edit-registration"
        },
        {
          text: i18n.t('navigation.changePassword'),
          path: "/change-password"
        },
        {
          text: i18n.t('navigation.logout'),
          path: "/logout"
        }
      ]
    }
  ];
}

// For backward compatibility, export a default array with English text
export const defaultNavigation = [
  {
    text: "Home",
    path: "/home",
    icon: "home"
  },
  {
    text: "Production Lines",
    icon: "aligncenter",
    items: [
      {
        text: "Production lines list",
        path: "/production-lines-list"
      }
    ]
  },
  {
    text: "Orders",
    icon: "cart",
    items: [
      {
        text: "Manage orders",
        path: "/orders",
      },
      {
        text: "New order",
        path: "/new-order",
      }
    ]
  },
  {
    text: "Forecasts",
    icon: "tableproperties",
    items: [
      {
        text: "Manage forecasts",
        path: "/forecasts"
      }
    ]
  },
  {
    text: "Manage Account",
    icon: "preferences",
    items: [
      {
        text: "Manage users",
        path: "/manage-account"
      }
    ]
  },
  {
    text: "Account",
    icon: "user",
    items: [
      {
        text: "Edit Registration",
        path: "/edit-registration"
      },
      {
        text: "Change Password",
        path: "/change-password"
      },
      {
        text: "Logout",
        path: "/logout"
      }
    ]
  }
];
